export const dialogStyle = {
  // maxHeight: { xs: "100%", sm: "800px" },
  "& .MuiPaper-root": {
    maxWidth: "1200px",
    display: "flex",
    flexDirection: "column",
  },
};

export const dialogBox = {
  height: { xs: "100%", sm: "min(800px, calc(100dvh - 64px))" },
  overflow: "hidden",
  // flex: 1,
  display: "flex",
  flexDirection: "column",
};

export const dialogContentStyle = {
  p: 0,
  flex: 1,
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  background: { xs: "#F9F9FC", sm: "none" },
  overflow: "hidden",
};

export const leftSectionStyle = {
  overflow: "auto",
  maxHeight: "100%",
  minHeight: 0,
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

export const rightSectionStyle = {
  flex: 1,
  p: { xs: "0px", md: "24px" },
  background: { xs: "#fff", md: "#f8f7fa" },
  overflow: "auto",
  maxHeight: "100%",
  minHeight: 0,

  scrollbarWidth: { xs: "none", md: "thin" },
  "&::-webkit-scrollbar": {
    display: { xs: "none", md: "block" },
  },
};

export const supplierFooterStyle = {
  paddingY: "12px",
  paddingX: "24px",
  boxShadow: "0px -3px 8px 0px #2F2B3D14",
  zIndex: 1,
};

export const headerBoxStyle = {
  paddingX: { xs: "16px", md: "24px" },
  paddingY: "12px",
  borderBottom: "1px solid #EAEAEA",
  boxShadow: { xs: "none", md: "0px 3px 8px 0px #2F2B3D14" },
  zIndex: 1,
};

export const chipStyle = {
  backgroundColor: "#24B06229",
  color: "#24B062",
  paddingX: "10px",
  paddingY: "4px",
  fontSize: "15px",
  fontWeight: "500",
  lineHeight: "22px",
  height: "30px",
  "& span": {
    padding: "0px",
  },
};

export const supplierInfoBoxStyle = {
  padding: { xs: "0px", md: "32px" },
  maxWidth: { xs: "100%", md: "268px" },
  borderRight: { xs: "none", md: "1px solid #EAEAEA" },
};

export const nameTextStyle = {
  color: "#2F2B3D",
  fontSize: "19px",
  fontWeight: 500,
  lineHeight: "120%",
};

export const infoTextStyle = {
  color: "#2F2B3DB2",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "20px",
};

export const aboutTextStyle = {
  color: "#2F2B3D",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "20px",
  mt: "12px",
  wordBreak: "break-word",
};

export const langTextStyle = {
  color: "#2F2B3D",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "20px",
};

export const VATTextStyle = {
  color: "rgba(72, 72, 72, 0.7)",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "20px",
};

export const dividerStyle = {
  borderColor: "#EAEAEA",
  my: "32px",
};

export const actionButtonStyle = {
  backgroundColor: "#257C6D",
  color: "white",
  fontSize: 15,
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "8px",
  paddingX: "12px",
  paddingY: "8px",
  height: "39px",
  boxShadow: "none !important",
  "&:hover": { backgroundColor: "#1F6A5A" },
};

export const declineActionBtn = {
  ...actionButtonStyle,
  backgroundColor: "#A5A5A5",
  "&:hover": { backgroundColor: "#8C8C8C" },
};

export const removeActionBtn = {
  ...actionButtonStyle,
  backgroundColor: "rgba(183, 72, 74, 1)",
  "&:hover": { backgroundColor: "rgba(183, 72, 74, 0.9)" },
  "&.Mui-disabled": {
    backgroundColor: "rgba(183, 72, 74, 0.4)",
    color: "#fff",
  },
};

// --- Products step ----------------------------------------------------------

export const avgDiscountChipStyle = {
  ...chipStyle,
  height: "28px",
  fontSize: "13px",
  borderRadius: "8px",
};

export const categoryDiscountChipStyle = {
  ...chipStyle,
  height: "24px",
  fontSize: "13px",
  ml: "12px",
};

export const stepperItemStyle = (active) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "default",
  color: active ? "#257C6D" : "#2F2B3D99",
  fontWeight: 500,
  fontSize: "15px",
  whiteSpace: "nowrap",
});

// Step indicator circle: a light-green disc with a teal number/check, matching the
// Figma (same look whether it holds a number or the completed ✓).
export const stepperBadgeStyle = () => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "22px",
  height: "22px",
  borderRadius: "50%",
  fontSize: "12px",
  fontWeight: 600,
  color: "#257C6D",
  backgroundColor: "#24B06229",
  flexShrink: 0,
});

export const productThumbStyle = {
  width: "32px",
  height: "32px",
  borderRadius: "6px",
  objectFit: "cover",
  flexShrink: 0,
};

export const productDetailPanelStyle = {
  position: { xs: "fixed", md: "absolute" },
  top: 0,
  bottom: 0,
  insetInlineEnd: 0,
  width: { xs: "100%", md: "360px" },
  background: "#fff",
  borderInlineStart: "1px solid #EAEAEA",
  boxShadow: "-4px 0px 16px 0px #2F2B3D14",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  // Must sit above CustomTable's sticky headers (z-index 99) so they don't bleed through.
  zIndex: 1000,
  scrollbarWidth: "thin",
};

// Transparent backdrop behind the product detail panel — clicking it (i.e. outside
// the panel) closes the detail. Sits just below the panel (z-index 1000).
export const detailBackdropStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 999,
  backgroundColor: "transparent",
};

// Carousel prev/next arrows matching the members product carousel: a translucent
// dark circle (foreground/30 → rgba(72,72,72,…)) with a white chevron and blur.
export const carouselArrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  insetInlineStart: side === "start" ? "12px" : "auto",
  insetInlineEnd: side === "end" ? "12px" : "auto",
  width: "36px",
  height: "36px",
  backgroundColor: "rgba(72, 72, 72, 0.3)",
  backdropFilter: "blur(4px)",
  "&:hover": { backgroundColor: "rgba(72, 72, 72, 0.45)" },
});

// Discount tag matching the members app (dashed dark-green border, light-green
// fill, tag icon). Tokens: light-green #E8F5F1, dark-green #005546.
export const discountTagStyle = {
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  paddingX: "12px",
  paddingY: "6px",
  minWidth: "64px",
  borderRadius: "6px",
  border: "2px dashed rgba(0, 85, 70, 0.5)",
  backgroundColor: "#E8F5F1",
  color: "#005546",
  fontWeight: 600,
  fontSize: "14px",
  flexShrink: 0,
};

export const supplierStatusBtnStyles = {
  ...actionButtonStyle,
  marginTop: "16px",
  fontSize: "13px",
  color: "#2F2B3D",
  gap: "8px",
  py: "8px",
  height: "30px",
  borderRadius: "6px",
  backgroundColor: "#F2F3FB",
  "&:hover": { backgroundColor: "#E0E2F4" },
};
